{
    "table": {
        "paging": {
            "showAll": "All",
            "rowsPerPage": "Rows per page",
            "info": "Rows %{from} to %{to} (%{count} items)"
        },
        "no_data": "No data",
        "loading_data": "Loading...",
        "empty": {
            "filtered": "Nothing matches your search or filters",
            "alerts": "No alerts yet",
            "api": "No API keys yet",
            "archives": "No archives yet",
            "calibrations": "No calibrations yet",
            "certificates": "No certificates yet",
            "invitations": "No pending invitations",
            "organizations": "No organizations yet",
            "partnerships": "No partnerships yet",
            "reports": "No reports yet",
            "users": "No users yet",
            "webhooks": "No webhooks yet",
            "webhooks_hint": "Webhooks send device data and alert notifications to your own systems.",
            "devices": "No devices yet",
            "devices_hint": "Claim a device and it will appear here.",
            "api_hint": "API keys let your own applications read your organization's data."
        }
    }
}
